export default "__VITE_ASSET__BY2tLTqn__"